import { render, staticRenderFns } from "./json-view-dialog-tabs.vue?vue&type=template&id=c81780e2&"
import script from "./json-view-dialog-tabs.vue?vue&type=script&lang=ts&"
export * from "./json-view-dialog-tabs.vue?vue&type=script&lang=ts&"
import style0 from "./json-view-dialog-tabs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports